import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { useIsFullscriptJsVar } from "@shared/reactiveVar/useIsFullscriptJs/useIsFullscriptJs.store";

const useAppcues = () => {
  const { e2e, isUnauthenticated, isAdminImpersonating, isPractitioner, isClerk } =
    useSharedGlobalConfig();

  const isFullscriptJs = useIsFullscriptJsVar();

  return (
    !e2e &&
    !isFullscriptJs &&
    !isUnauthenticated &&
    !isAdminImpersonating &&
    (isPractitioner || isClerk)
  );
};

export { useAppcues };
